(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7523],{

/***/ 72303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fc": function() { return /* binding */ CompatibleComponentMapV2; },
  "xL": function() { return /* binding */ FormComponentMap; },
  "gX": function() { return /* binding */ UIComponentMap; },
  "dl": function() { return /* binding */ formComponentMapToType; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-grid-layout/index.js
var react_grid_layout = __webpack_require__(69968);
var react_grid_layout_default = /*#__PURE__*/__webpack_require__.n(react_grid_layout);
// EXTERNAL MODULE: ./components/index.ts + 8 modules
var components = __webpack_require__(77223);
// EXTERNAL MODULE: ./node_modules/@wartek-id/card/dist/index.esm.js
var index_esm = __webpack_require__(85584);
// EXTERNAL MODULE: ./node_modules/@wartek-id/carousel/dist/index.esm.js
var dist_index_esm = __webpack_require__(66809);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js
var text_dist_index_esm = __webpack_require__(73041);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 54 modules
var icon_dist_index_esm = __webpack_require__(67600);
// EXTERNAL MODULE: ./node_modules/@wartek-id/rating/dist/index.esm.js + 1 modules
var rating_dist_index_esm = __webpack_require__(26167);
// EXTERNAL MODULE: ./node_modules/@wartek-id/separator/dist/index.esm.js
var separator_dist_index_esm = __webpack_require__(49168);
// EXTERNAL MODULE: ./node_modules/@wartek-id/avatar/dist/index.esm.js
var avatar_dist_index_esm = __webpack_require__(27188);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(50121);
// EXTERNAL MODULE: ./node_modules/@wartek-id/badge/dist/index.esm.js
var badge_dist_index_esm = __webpack_require__(3741);
// EXTERNAL MODULE: ./node_modules/@wartek-id/list/dist/index.esm.js
var list_dist_index_esm = __webpack_require__(86228);
// EXTERNAL MODULE: ./node_modules/@wartek-id/banner/dist/index.esm.js
var banner_dist_index_esm = __webpack_require__(30554);
// EXTERNAL MODULE: ./node_modules/@wartek-id/progress-bar/dist/index.esm.js
var progress_bar_dist_index_esm = __webpack_require__(77185);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js
var shimmer_dist_index_esm = __webpack_require__(76755);
// EXTERNAL MODULE: ./node_modules/@wartek-id/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(54764);
// EXTERNAL MODULE: ./node_modules/@wartek-id/tooltip/dist/index.esm.js + 54 modules
var tooltip_dist_index_esm = __webpack_require__(95109);
// EXTERNAL MODULE: ./node_modules/@wartek-id/tabs/dist/index.esm.js + 2 modules
var tabs_dist_index_esm = __webpack_require__(21192);
// EXTERNAL MODULE: ./node_modules/@wartek-id/breadcrumb/dist/index.esm.js
var breadcrumb_dist_index_esm = __webpack_require__(3995);
// EXTERNAL MODULE: ./node_modules/@wartek-id/navbar/dist/index.esm.js
var navbar_dist_index_esm = __webpack_require__(5871);
// EXTERNAL MODULE: ./node_modules/@wartek-id/link/dist/index.esm.js
var link_dist_index_esm = __webpack_require__(63004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(55837);
// EXTERNAL MODULE: ./node_modules/@wartek-id/radio/dist/index.esm.js
var radio_dist_index_esm = __webpack_require__(34003);
// EXTERNAL MODULE: ./node_modules/@wartek-id/collapsible/dist/index.esm.js
var collapsible_dist_index_esm = __webpack_require__(13510);
// EXTERNAL MODULE: ./node_modules/@wartek-id/expander/dist/index.esm.js + 4 modules
var expander_dist_index_esm = __webpack_require__(36655);
// EXTERNAL MODULE: ./node_modules/@wartek-id/popover/dist/index.esm.js + 54 modules
var popover_dist_index_esm = __webpack_require__(62813);
// EXTERNAL MODULE: ./node_modules/@wartek-id/select/dist/index.esm.js + 1 modules
var select_dist_index_esm = __webpack_require__(45431);
// EXTERNAL MODULE: ./node_modules/@wartek-id/stepper/dist/index.esm.js
var stepper_dist_index_esm = __webpack_require__(57858);
// EXTERNAL MODULE: ./node_modules/@wartek-id/switch/dist/index.esm.js + 3 modules
var switch_dist_index_esm = __webpack_require__(81505);
// EXTERNAL MODULE: ./node_modules/@wartek-id/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(24050);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 6 modules
var format = __webpack_require__(74201);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getDay/index.js
var getDay = __webpack_require__(20466);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(95826);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 42 modules
var parse = __webpack_require__(63672);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
// EXTERNAL MODULE: ./node_modules/react-big-calendar/dist/react-big-calendar.esm.js
var react_big_calendar_esm = __webpack_require__(96827);
// EXTERNAL MODULE: ./node_modules/react-big-calendar/lib/css/react-big-calendar.css
var react_big_calendar = __webpack_require__(68465);
;// CONCATENATED MODULE: ./components/ComponentBuilder/CustomSchemaComponent/Calendar/index.tsx










var locales = {
    "en-US": en_US/* default */.Z
};
var localizer = (0,react_big_calendar_esm/* dateFnsLocalizer */.lD)({
    format: format/* default */.Z,
    parse: parse/* default */.Z,
    startOfWeek: startOfWeek/* default */.Z,
    getDay: getDay/* default */.Z,
    locales: locales
});
var CalendarComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_big_calendar_esm/* Calendar */.f, (0,_object_spread/* default */.Z)({
        localizer: localizer,
        events: [],
        startAccessor: "start",
        endAccessor: "end"
    }, props));
};

;// CONCATENATED MODULE: ./components/ComponentBuilder/CustomSchemaComponent/index.ts


;// CONCATENATED MODULE: ./components/ComponentBuilder/ComponentMap.tsx








// unregistered component in library

var CompatibleComponentMapV2 = {
    div: {
        props: {
            className: "p-4 h-full"
        },
        children: []
    },
    Calendar: {
        props: {
            style: {
                height: "500px"
            }
        }
    },
    Card: {
        props: {
            className: "p-4"
        },
        children: []
    },
    ImageHTML: {
        props: {
            className: "w-full",
            src: "https://wallpaperaccess.com/full/32048.jpg",
            width: "300px",
            height: "300px"
        }
    },
    Image: {
        props: {
            src: "https://wallpaperaccess.com/full/32048.jpg"
        }
    },
    Avatar: {
        props: {
            alt: "Some Alt",
            shape: "circle",
            className: "",
            size: "md",
            src: "https://avatars.githubusercontent.com/u/5605?s=48&v=4"
        }
    },
    Badge: {
        props: {
            content: "hehehehe",
            className: "p-4",
            variant: ""
        }
    },
    Link: {
        props: {
            variant: "primary",
            className: "p",
            href: "https://google.com"
        },
        children: []
    },
    List: {
        props: {
            type: "list",
            className: "p-4"
        },
        children: []
    },
    ListItem: {
        props: {
            content: "List Item",
            className: "p-4"
        }
    },
    Text: {
        props: {
            content: "Text",
            className: "p-4",
            variant: "subheading"
        }
    },
    Separator: {
        props: {
            className: "p-1"
        }
    },
    Button: {
        props: {
            content: "Button",
            className: "p-4",
            variant: "primary",
            type: "button"
        },
        children: [
            {
                component: "Text",
                props: {
                    content: "Button",
                    className: "p-4",
                    variant: "subheading"
                }
            }, 
        ]
    },
    Icon: {
        props: {
            color: "inherit",
            className: "p-4",
            content: "tune"
        }
    },
    Banner: {
        props: {
            className: "p-4",
            content: "Banner",
            variant: ""
        }
    },
    ProgressBar: {
        props: {
            className: "p-4",
            variant: ""
        }
    },
    Carousel: {
        props: {},
        children: []
    },
    // Tab: {
    //   props: {
    //     content: 'tab x',
    //   },
    // },
    // Tabs: {
    //   props: {},
    //   children: [],
    // },
    // TabList: {
    //   props: {},
    //   children: [],
    // },
    // TabPanels: {
    //   props: {},
    //   children: [],
    // },
    // TabPanel: {
    //   props: {},
    //   children: [],
    // },
    Navbar: {
        props: {
            avatar: "https://avatars.githubusercontent.com/u/5605?s=48&v=4",
            email: "email@gmail.com",
            menuItems: [
                {
                    active: true,
                    href: "#menu-1",
                    id: "menu-1",
                    newBadge: false,
                    text: "Menu 1"
                }, 
            ],
            profileItems: [
                {
                    active: false,
                    href: "#profile-menu-1",
                    id: "profile-menu-1",
                    newBadge: false,
                    text: "Profile Menu 1"
                }, 
            ],
            username: "username"
        }
    },
    // Banner,
    // BannerDescription,
    // Breadcrumb,
    // Button,
    // Icon,
    Form: {
        props: {
            action: "/my-handling-form-page",
            method: "post"
        },
        children: []
    },
    Input: {
        props: {
            id: "input-1",
            name: "input-1",
            className: ""
        }
    },
    // InputGroup,
    // InputLeftAddon,
    // List,
    // ListItem,
    // ProgressBar,
    RadioGroup: {
        props: {
            id: "radio-group-1",
            name: "radio-group",
            className: "flex flex-col mt-2"
        },
        children: []
    },
    Radio: {
        props: {
            id: "Option-1",
            value: "Option 1",
            label: "Option 1",
            className: "mt-1"
        }
    }
};
// TODO: add more map
var UIComponentMap = {
    div: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
            className: props.className
        }, props), props === null || props === void 0 ? void 0 : props.id);
    },
    GridLayout: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)((react_grid_layout_default()), (0,_object_spread/* default */.Z)({}, props), props === null || props === void 0 ? void 0 : props.id);
    },
    Calendar: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CalendarComponent, (0,_object_spread/* default */.Z)({}, props), props === null || props === void 0 ? void 0 : props.id);
    },
    a: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    hrefContainer: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    ImageHTML: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: props.onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: props.className,
                src: props.src || "https://wallpaperaccess.com/full/32048.jpg",
                width: props.width || 200,
                height: props.height || 200
            }, props.id)
        });
    },
    Image: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
            className: props.className,
            src: props.src || "https://img.freepik.com/free-vector/cute-cat-sleeping-laptop-with-coffee-cartoon-vector-icon-illustration-animal-technology-icon_138676-4475.jpg",
            width: props.width,
            height: props.height,
            alt: props.alt || "Some Alt"
        }, props.id);
    },
    Card: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Card */.Zb, (0,_object_spread/* default */.Z)({}, props), props === null || props === void 0 ? void 0 : props.id);
    },
    Carousel: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Carousel */.l, (0,_object_spread/* default */.Z)({}, props), props === null || props === void 0 ? void 0 : props.id);
    },
    span: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Text: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Icon: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Rating: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rating_dist_index_esm/* Rating */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: props.content
            })
        }), props.id);
    },
    Separator: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(separator_dist_index_esm/* Separator */.Z, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Avatar: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Button: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Badge: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    List: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dist_index_esm/* List */.a, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    ListItem: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dist_index_esm/* ListItem */.H, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    ListItemAsContainer: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dist_index_esm/* ListItem */.H, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Banner: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_dist_index_esm/* Banner */.jL, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_dist_index_esm/* BannerDescription */.gS, {
                children: props.content
            })
        }), props.id);
    },
    ProgressBar: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar_dist_index_esm/* ProgressBar */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Shimmer: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Spinner: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Tooltip: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    // eslint-disable-next-line
    // Image: (props) => <Image key={props.id} {...props} />,
    Tabs: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* Tabs */.mQ, (0,_object_spread/* default */.Z)({}, props))
        });
    },
    Tab: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* Tab */.OK, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    TabList: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabList */.td, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    TabPanels: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanels */.nP, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    TabPanel: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanel */.x4, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Breadcrumb: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_dist_index_esm/* Breadcrumb */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Navbar: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_dist_index_esm/* Navbar */.wp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: props.content
        }), props.id);
    },
    Link: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_dist_index_esm/* Link */.r, (0,_object_spread/* default */.Z)({}, props), props.id);
    },
    Input: function(props) {
        // eslint-disable-next-line unused-imports/no-unused-vars
        var children = props.children, propsWithoutChildren = (0,_object_without_properties/* default */.Z)(props, [
            "children"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({}, propsWithoutChildren), props.id);
    },
    Form: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onSubmit: function(event) {
                event.preventDefault();
            }
        }), props.id);
    },
    RadioGroup: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* RadioGroup */.Ee, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref
        }), props.id);
    },
    Radio: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
            value: String(props.value) || String(props.id),
            className: "mr-4",
            children: props.label
        }, props.id);
    },
    Collapsible: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsible_dist_index_esm/* Collapsible */.zF, (0,_object_spread/* default */.Z)({}, props));
    },
    CollapsibleTrigger: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsible_dist_index_esm/* CollapsibleTrigger */.wy, (0,_object_spread/* default */.Z)({}, props));
    },
    CollapsibleIcon: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsible_dist_index_esm/* CollapsibleIcon */.FN, (0,_object_spread/* default */.Z)({}, props));
    },
    CollapsibleContent: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsible_dist_index_esm/* CollapsibleContent */.Fw, (0,_object_spread/* default */.Z)({}, props));
    },
    Expander: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(expander_dist_index_esm/* Expander */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            maxTextLength: 100
        }, props), {
            as: "p",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "whitespace-pre-line",
                children: "".concat(props.content)
            })
        }));
    },
    Popover: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* Popover */.J2, (0,_object_spread/* default */.Z)({}, props));
    },
    PopoverTrigger: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, (0,_object_spread/* default */.Z)({}, props));
    },
    PopoverContent: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverContent */.yk, (0,_object_spread/* default */.Z)({}, props));
    },
    ButtonDropdownMenu: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
            placement: props.placement || "bottom-end",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.z, {
                        className: props.className,
                        variant: props.variant,
                        color: props.color,
                        children: [
                            props.triggerText,
                            " ",
                            props.iconName && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                children: props.iconName
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverContent */.yk, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dist_index_esm/* List */.a, {
                        type: "menu",
                        children: props.items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: item.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dist_index_esm/* ListItem */.H, {
                                    onClick: item.onClick,
                                    children: item.text
                                }, item.id)
                            }, item.id);
                        })
                    })
                })
            ]
        });
    }
};
// TODO: add more form component
var FormComponentMap = {
    // DatePicker: (props) => (
    //   <DatePicker key={props.id} {...props} ref={props.ref} />
    // ),
    // Fileupload: (props) => (
    //   <Fileupload key={props.id} {...props} ref={props.ref} />
    // ),
    Input: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref,
            className: "rounded border-2 p-2 ".concat(props.className)
        }), props.id);
    },
    // TODO: to adjust fit any addon
    InputAddon: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftAddon */.Ui, {
                    style: {
                        width: "50px",
                        marginLeft: "8px",
                        marginTop: 8
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        color: "disabled",
                        children: props.leftAddons
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    ref: props.ref,
                    style: {
                        paddingLeft: "58px"
                    }
                }), props.id)
            ]
        });
    },
    Radio: function(props) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(radio_dist_index_esm/* RadioGroup */.Ee, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref,
            children: (ref = props.options) === null || ref === void 0 ? void 0 : ref.map(function(option, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                    value: String(option.value) || String(option.id),
                    className: "mr-4",
                    children: option.label
                }, index);
            })
        }), props.id);
    },
    Select: function(props) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref,
            children: (ref = props.options) === null || ref === void 0 ? void 0 : ref.map(function(option, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: option.value || option.id,
                    children: option.label
                }, index);
            })
        }), props.id);
    },
    Stepper: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(stepper_dist_index_esm/* Stepper */.v, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref
        }), props.id);
    },
    Switch: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(switch_dist_index_esm/* Switch */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            onCheckedChange: props.onChange,
            ref: props.ref
        }), props.id);
    },
    Textarea: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: props.ref
        }), props.id);
    }
};
var formComponentMapToType = {
    string: [
        "Input",
        "Textarea",
        "DatePicker"
    ],
    number: [
        "Input",
        "Textarea"
    ],
    boolean: [
        "Radio",
        "Select",
        "Switch"
    ],
    date: [
        "DatePicker"
    ],
    file: [
        "Fileupload"
    ],
    array: [
        "Select",
        "Checkbox",
        "Radio"
    ],
    object: [
        "Select",
        "Checkbox",
        "Radio"
    ]
};
/* harmony default export */ var ComponentMap = ((/* unused pure expression or super */ null && (FormComponentMap)));


/***/ }),

/***/ 67154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ getSchemaLegendByName; }
/* harmony export */ });
/* unused harmony export schemaLegendMap */
var getSchemaLegendByName = function(schemaName) {
    return schemaLegendMap[schemaName] || {
        iconName: "code_block",
        labelName: "Custom Component",
        componentType: "container"
    };
};
var schemaLegendMap = {
    div: {
        iconName: "fullscreen",
        labelName: "Div Container",
        componentType: "container"
    },
    Calendar: {
        iconName: "calendar_month",
        labelName: "Calendar",
        componentType: "node"
    },
    Card: {
        iconName: "font_download",
        labelName: "Card Container",
        componentType: "container"
    },
    ImageHTML: {
        iconName: "image",
        labelName: "Image",
        componentType: "node"
    },
    Image: {
        iconName: "image",
        labelName: "Image",
        componentType: "node"
    },
    Avatar: {
        iconName: "account_circle",
        labelName: "User Avatar",
        componentType: "node"
    },
    Badge: {
        iconName: "toggle_on",
        labelName: "Pill Badge",
        componentType: "node"
    },
    Link: {
        iconName: "link",
        labelName: "URL Container",
        componentType: "container"
    },
    List: {
        iconName: "view_list",
        labelName: "List Container",
        componentType: "container"
    },
    ListItem: {
        iconName: "list",
        labelName: "List Item",
        componentType: "node"
    },
    ListItemAsContainer: {
        iconName: "list",
        labelName: "List Item Container",
        componentType: "container"
    },
    Text: {
        iconName: "title",
        labelName: "Text",
        componentType: "node"
    },
    span: {
        iconName: "title",
        labelName: "Inline Text",
        componentType: "node"
    },
    Separator: {
        iconName: "horizontal_rule",
        labelName: "Line Separator",
        componentType: "node"
    },
    Button: {
        iconName: "crop_16_9",
        labelName: "Button",
        componentType: "node"
    },
    Icon: {
        iconName: "insert_emoticon",
        labelName: "Material Icon",
        componentType: "node"
    },
    Banner: {
        iconName: "campaign",
        labelName: "Closable Banner",
        componentType: "node"
    },
    ProgressBar: {
        iconName: "percent",
        labelName: "Progress Bar",
        componentType: "node"
    },
    Carousel: {
        iconName: "view_carousel",
        labelName: "Slider Carousel Container",
        componentType: "container"
    },
    Form: {
        iconName: "edit_note",
        labelName: "Form Container",
        componentType: "container"
    },
    Input: {
        iconName: "text_fields",
        labelName: "Text Input",
        componentType: "node"
    },
    RadioGroup: {
        iconName: "radio_button_checked",
        labelName: "Radio Group Container",
        componentType: "container"
    },
    Radio: {
        iconName: "radio_button_checked",
        labelName: "Radio Input",
        componentType: "node"
    },
    Popover: {
        iconName: "difference",
        labelName: "Popover Container",
        componentType: "container"
    },
    Expander: {
        iconName: "expand_more",
        labelName: "Expander Container",
        componentType: "container"
    },
    Collapsible: {
        iconName: "unfold_more",
        labelName: "Collapsible Container",
        componentType: "container"
    },
    ButtonDropdownMenu: {
        iconName: "difference",
        labelName: "Button Dropdown Menu",
        componentType: "node"
    },
    hrefContainer: {
        iconName: "link",
        labelName: "<a> Node </a>",
        componentType: "container"
    }
};


/***/ }),

/***/ 44298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WG": function() { return /* binding */ getSectionSchemaList; },
/* harmony export */   "yr": function() { return /* binding */ getSectionSchemaByName; }
/* harmony export */ });
/* unused harmony export SectionSchemaMap */
var CENTER_FLEX_CLASS = "items-center justify-center content-center";
var placeholderSchema = {
    componentName: "div",
    sectionPlaceholder: true,
    props: {
        className: "flex ".concat(CENTER_FLEX_CLASS, " w-full h-full min-h-[150px] rounded-lg bg-gray-200 p-1"),
        style: {
            pointerEvents: "none"
        }
    },
    iconName: "rectangle",
    labelName: "<Div> Container",
    componentType: "container",
    children: [
        {
            componentName: "div",
            props: {
                className: "text-center"
            },
            iconName: "rectangle",
            labelName: "<Div> Container",
            componentType: "container",
            children: [
                {
                    componentName: "Icon",
                    iconName: "insert_emoticon",
                    labelName: "Material Icon",
                    componentType: "node",
                    props: {
                        className: "text-gray-400",
                        content: "photo",
                        fontSize: "large",
                        style: {
                            pointerEvents: "none"
                        }
                    }
                },
                {
                    componentName: "span",
                    iconName: "title",
                    labelName: "Span",
                    componentType: "node",
                    props: {
                        className: "text-gray-400 text-weight-bold",
                        content: "Component Placeholder",
                        style: {
                            pointerEvents: "none"
                        }
                    }
                }, 
            ]
        }, 
    ]
};
var getSectionSchemaList = function() {
    var sectionSchemaNameList = SectionSchemaMap.map(function(sectionSchema) {
        return {
            name: sectionSchema.sectionName,
            icon: sectionSchema.iconName || "add",
            iconStyle: sectionSchema.iconStyle || {}
        };
    });
    return sectionSchemaNameList;
};
var getSectionSchemaByName = function(sectionName) {
    var findSection = SectionSchemaMap.find(function(schema) {
        return schema.sectionName === sectionName;
    });
    if (!findSection) {
        return SectionSchemaMap[0];
    }
    return findSection;
};
var SectionSchemaMap = [
    // 1 full row
    {
        componentName: "div",
        sectionName: "oneFullRow",
        iconName: "calendar_view_day",
        props: {
            className: "flex items-center bg-white w-full p-4"
        },
        children: [
            placeholderSchema
        ]
    },
    // split 50:50
    {
        componentName: "div",
        sectionName: "splitHalf",
        iconName: "splitscreen",
        iconStyle: {
            transform: "rotate(90deg)"
        },
        props: {
            className: "grid grid-flow-col-dense gap-2 p-4"
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "flex flex-row items-center w-full row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "flex flex-row items-center w-full row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            }, 
        ]
    },
    // split 33:33:33
    {
        componentName: "div",
        sectionName: "splitThird",
        iconName: "view_column",
        props: {
            className: "grid grid-flow-col-dense gap-2 p-4"
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            }, 
        ]
    },
    // split 25:25:25:25
    {
        componentName: "div",
        sectionName: "splitQuarter",
        iconName: "calendar_view_week",
        props: {
            className: "grid grid-flow-col-dense gap-2 p-4"
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            }, 
        ]
    },
    // split 50: [50:50]
    {
        componentName: "div",
        sectionName: "splitHalfRightHalf",
        iconName: "space_dashboard",
        props: {
            className: "grid grid-flow-col-dense gap-2 p-4"
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "col-span-1"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-2 col-span-1"
                },
                children: [
                    placeholderSchema
                ]
            }, 
        ]
    },
    // split [50:50]: 50
    {
        componentName: "div",
        sectionName: "splitHalfLeftHalf",
        iconName: "space_dashboard",
        iconStyle: {
            transform: "rotate(180deg)"
        },
        props: {
            className: "grid grid-flow-col-dense gap-2 p-4"
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "col-span-1"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-2 col-span-1"
                },
                children: [
                    placeholderSchema
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "row-span-3"
                },
                children: [
                    placeholderSchema
                ]
            }, 
        ]
    },
    //   split [1:4] [1:4] [1:4]
    {
        componentName: "div",
        sectionName: "splitOneFourthTimesThree",
        iconName: "list",
        props: {
            className: ""
        },
        children: [
            {
                componentName: "div",
                props: {
                    className: "grid grid-flow-col-dense gap-2 px-4 py-1"
                },
                children: [
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1"
                        },
                        children: [
                            placeholderSchema
                        ]
                    },
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1 col-span-3"
                        },
                        children: [
                            placeholderSchema
                        ]
                    }, 
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "grid grid-flow-col-dense gap-2 px-4 py-1"
                },
                children: [
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1"
                        },
                        children: [
                            placeholderSchema
                        ]
                    },
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1 col-span-3"
                        },
                        children: [
                            placeholderSchema
                        ]
                    }, 
                ]
            },
            {
                componentName: "div",
                props: {
                    className: "grid grid-flow-col-dense gap-2 px-4 py-1"
                },
                children: [
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1"
                        },
                        children: [
                            placeholderSchema
                        ]
                    },
                    {
                        componentName: "div",
                        props: {
                            className: "row-span-1 col-span-3"
                        },
                        children: [
                            placeholderSchema
                        ]
                    }, 
                ]
            }, 
        ]
    }, 
];


/***/ }),

/***/ 77223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uK": function() { return /* reexport */ CanvasRenderer; },
  "Qw": function() { return /* reexport */ ComponentBuilder; },
  "OR": function() { return /* reexport */ ComponentRenderer; },
  "qu": function() { return /* reexport */ FormBuilder; },
  "LM": function() { return /* reexport */ GridBuilder; },
  "Ee": function() { return /* reexport */ Image; },
  "ro": function() { return /* reexport */ useFormBuilderContext; }
});

// UNUSED EXPORTS: InputBuilder, getSchemaLegendByName, schemaLegendMap

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 54 modules
var index_esm = __webpack_require__(67600);
// EXTERNAL MODULE: ./node_modules/@wartek-id/popover/dist/index.esm.js + 54 modules
var dist_index_esm = __webpack_require__(62813);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(50121);
// EXTERNAL MODULE: ./components/ComponentBuilder/SchemaLegend.ts
var SchemaLegend = __webpack_require__(67154);
// EXTERNAL MODULE: ./components/ComponentBuilder/presets/section.ts
var section = __webpack_require__(44298);
;// CONCATENATED MODULE: ./components/ComponentBuilder/blocks/SectionPopoverContent.tsx




var SectionPopoverContent = function(props) {
    var onSectionSelect = props.onSectionSelect;
    var sectionList = (0,section/* getSectionSchemaList */.WG)();
    var handleSelectSection = function(sectionName) {
        var sectionSchema = (0,section/* getSectionSchemaByName */.yr)(sectionName);
        onSectionSelect(sectionSchema);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-weight mb-4",
                children: "Select Layout"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row",
                children: sectionList.map(function(section) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                        color: "white",
                        iconOnly: true,
                        className: "mr-2",
                        "data-tooltip": section.name,
                        onClick: function() {
                            return handleSelectSection(section.name);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                            style: section.iconStyle,
                            color: "inherit",
                            children: section.icon
                        })
                    }, section.name);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ComponentBuilder/ComponentMap.tsx + 2 modules
var ComponentMap = __webpack_require__(72303);
;// CONCATENATED MODULE: ./components/ComponentBuilder/SchemaUtils.ts

var DefaultComponentMap = "div";
var getSelectedComponentByName = function(componentName) {
    var componentByName = componentName || DefaultComponentMap;
    var getComponentMap = ComponentMap/* UIComponentMap */.gX;
    if (getComponentMap[componentByName]) {
        return getComponentMap[componentByName];
    }
    return null;
};
var isObjectEmpty = function(obj) {
    for(var key in obj){
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};
var filterEmptyObjectFromArray = function(arr) {
    return arr && (arr === null || arr === void 0 ? void 0 : arr.filter(function(obj) {
        return !isObjectEmpty(obj);
    }));
};

;// CONCATENATED MODULE: ./components/ComponentBuilder/CanvasRenderer.tsx
// TODO: UNTESTED! Test this alongside with web builder page implementation
// TODO: rework Container highlight, the node hightlight seems ok










var DEFAULT_OUTLINE_CLASS = "cursor-pointer hover:relative hover:outline hover:z-20 hover:outline-violet-300 outline-offset-[-1px] outline-violet-500";
var CanvasContainerHighlighter = function(props) {
    var componentNodeData = props.componentNodeData, isHighlighted = props.isHighlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute top-[-28px] z-30 group-hover:visible  ".concat(isHighlighted ? "visible" : "invisible"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: " bg-blue-500 p-2 text-xs text-white",
            style: {
                fontWeight: "bold",
                fontSize: "10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                    color: "inherit",
                    fontSize: "sm",
                    className: "mr-2",
                    children: (0,SchemaLegend/* getSchemaLegendByName */.h)(componentNodeData.componentName).iconName
                }),
                (0,SchemaLegend/* getSchemaLegendByName */.h)(componentNodeData.componentName).labelName
            ]
        })
    });
};
var CanvasNodeHightlightWrapper = function(props) {
    var children = props.children, componentNodeData = props.componentNodeData, isHighlighted = props.isHighlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            isHighlighted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(isHighlighted ? "visible" : "invisible", " absolute top-[-32px] z-30 flex rounded"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "max-h-[100px] truncate bg-green-500 p-2 text-white",
                    style: {
                        fontWeight: "bold",
                        fontSize: "10px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                            color: "inherit",
                            fontSize: "sm",
                            className: "mr-2",
                            children: (0,SchemaLegend/* getSchemaLegendByName */.h)(componentNodeData.componentName).iconName
                        }),
                        (0,SchemaLegend/* getSchemaLegendByName */.h)(componentNodeData.componentName).labelName
                    ]
                })
            }),
            children
        ]
    });
};
var HighlightCanvasWrapper = function(props) {
    var ref;
    var isHighlighted = props.isHighlighted, nodeHightlightProps = props.nodeHightlightProps, children = props.children, nodeIndex = props.nodeIndex, onHightlightNodeAddClick = props.onHightlightNodeAddClick, onHightlightNodeDeleteClick = props.onHightlightNodeDeleteClick;
    var isSingleNode = !((ref = nodeHightlightProps.componentNodeData) === null || ref === void 0 ? void 0 : ref.children);
    if (isSingleNode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasNodeHightlightWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nodeHightlightProps), {
            isHighlighted: isHighlighted,
            onHightlightNodeAddClick: onHightlightNodeAddClick,
            onHightlightNodeDeleteClick: onHightlightNodeDeleteClick,
            nodeIndex: nodeIndex,
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var RenderCanvas = function(props) {
    var data = props.data, highlightedId = props.highlightedId, nodeConfig = props.nodeConfig, deleteSelectedNode = props.deleteSelectedNode, moveNodeOrder = props.moveNodeOrder, triggerDoubleClick = props.triggerDoubleClick, onNodeClick = props.onNodeClick, nodeIndex = props.nodeIndex, onAddSection = props.onAddSection, disabledAddSection = props.disabledAddSection, onHightlightNodeAddClick = props.onHightlightNodeAddClick, onHightlightNodeDeleteClick = props.onHightlightNodeDeleteClick, onHightlightContainerAddClick = props.onHightlightContainerAddClick, onHightlightContainerDeleteClick = props.onHightlightContainerDeleteClick;
    var componentDataList = data;
    if (!componentDataList || componentDataList.length === 0) {
        return null;
    }
    return componentDataList.map(function(componentNodeData) {
        var ref;
        var SelectedComponent = getSelectedComponentByName(componentNodeData.componentName);
        var _$props = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.props) || {};
        var childrenNode = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.children) || [];
        var childNodes = filterEmptyObjectFromArray(childrenNode);
        var componentClassName = (componentNodeData === null || componentNodeData === void 0 ? void 0 : (ref = componentNodeData.props) === null || ref === void 0 ? void 0 : ref.className) || "";
        var componentId = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.componentId) || "";
        // TODO: Rework This Node Move Method
        var isHighlighted = componentId === highlightedId;
        var isContainer = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.children) || componentNodeData.componentName === "div";
        var isContainerAndHighlighted = isContainer && isHighlighted;
        var isNodeAndHighlighted = !isContainer && isHighlighted;
        // Section container  - first child of the tree
        // for user we need to make this easy enough to add new section
        var isSectionContainer = (nodeIndex === null || nodeIndex === void 0 ? void 0 : nodeIndex.length) === 2;
        // temporary disabled, because it alter absolute component position when scrolling
        // if (isHighlighted) {
        //   const highlightedEl = document.querySelector(
        //     `[data-renderedId="${componentId}"]`
        //   );
        //   highlightedEl?.scrollIntoView({
        //     behavior: "smooth",
        //     // block: "center",
        //     // inline: "center",
        //   });
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HighlightCanvasWrapper, {
            isHighlighted: isNodeAndHighlighted,
            nodeHightlightProps: {
                componentNodeData: componentNodeData,
                isHighlighted: isNodeAndHighlighted
            },
            nodeIndex: nodeIndex,
            onHightlightNodeAddClick: onHightlightNodeAddClick,
            onHightlightNodeDeleteClick: onHightlightNodeDeleteClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                    "data-renderedId": componentId,
                    onClick: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        triggerDoubleClick && triggerDoubleClick(false);
                        onNodeClick({
                            selectedNode: componentNodeData,
                            index: nodeIndex || [
                                0
                            ]
                        });
                    },
                    onDoubleClick: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        triggerDoubleClick && triggerDoubleClick(true);
                    },
                    className: "".concat(componentClassName, " ").concat(isHighlighted && "relative z-20 outline-dashed", " ").concat(DEFAULT_OUTLINE_CLASS),
                    children: [
                        isContainer && isHighlighted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasContainerHighlighter, {
                            componentNodeData: componentNodeData,
                            isHighlighted: isContainerAndHighlighted,
                            nodeIndex: nodeIndex,
                            onHightlightContainerAddClick: onHightlightContainerAddClick,
                            onHightlightContainerDeleteClick: onHightlightContainerDeleteClick
                        }),
                        childNodes && childNodes.map(function(child, index) {
                            return RenderCanvas({
                                data: [
                                    child
                                ],
                                nodeConfig: nodeConfig,
                                highlightedId: highlightedId,
                                deleteSelectedNode: deleteSelectedNode,
                                moveNodeOrder: moveNodeOrder,
                                triggerDoubleClick: triggerDoubleClick,
                                onNodeClick: onNodeClick,
                                nodeIndex: (0,_to_consumable_array/* default */.Z)(nodeIndex || [
                                    0
                                ]).concat([
                                    index
                                ]),
                                onAddSection: onAddSection,
                                disabledAddSection: disabledAddSection,
                                onHightlightNodeAddClick: onHightlightNodeAddClick,
                                onHightlightNodeDeleteClick: onHightlightNodeDeleteClick,
                                onHightlightContainerAddClick: onHightlightContainerAddClick,
                                onHightlightContainerDeleteClick: onHightlightContainerDeleteClick
                            });
                        })
                    ]
                })),
                !disabledAddSection && isSectionContainer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-50 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 top-[-10px] flex w-full justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Popover */.J2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* PopoverTrigger */.xo, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                        iconOnly: true,
                                        color: "white",
                                        className: "opacity-20 hover:opacity-100",
                                        // @ts-ignore
                                        size: "small",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                            fontSize: "small",
                                            children: "add"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* PopoverContent */.yk, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionPopoverContent, {
                                        onSectionSelect: function(sectionData) {
                                            onAddSection({
                                                index: nodeIndex || [
                                                    0
                                                ],
                                                selectedNode: sectionData
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        }, "".concat(componentNodeData.componentName, "-").concat(componentId));
    });
};
var MemoizedCanvasRenderer = /*#__PURE__*/ react.memo(function(props) {
    return(// @ts-ignore <- bypass default renderer type (because we do custom render / pointer)
    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCanvas, (0,_object_spread/* default */.Z)({}, props)));
});
var CanvasRenderer = function(props) {
    var data = props.data, nodeConfig = props.nodeConfig, _deleteSelectedNode = props.deleteSelectedNode, deleteSelectedNode = _deleteSelectedNode === void 0 ? function() {
        return null;
    } : _deleteSelectedNode, _moveNodeOrder = props.moveNodeOrder, moveNodeOrder = _moveNodeOrder === void 0 ? function() {
        return null;
    } : _moveNodeOrder, _triggerDoubleClick = props.triggerDoubleClick, triggerDoubleClick = _triggerDoubleClick === void 0 ? function() {
        return null;
    } : _triggerDoubleClick, _onNodeClick = props.onNodeClick, onNodeClick = _onNodeClick === void 0 ? function() {
        return null;
    } : _onNodeClick, _selectedNodeId = props.selectedNodeId, selectedNodeId = _selectedNodeId === void 0 ? null : _selectedNodeId, _onAddSection = props.onAddSection, onAddSection = _onAddSection === void 0 ? function() {
        return null;
    } : _onAddSection, _disabledAddSection = props.disabledAddSection, disabledAddSection = _disabledAddSection === void 0 ? false : _disabledAddSection, onHightlightNodeAddClick = props.onHightlightNodeAddClick, onHightlightNodeDeleteClick = props.onHightlightNodeDeleteClick, onHightlightContainerAddClick = props.onHightlightContainerAddClick, onHightlightContainerDeleteClick = props.onHightlightContainerDeleteClick;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(selectedNodeId), 2), selectedId = ref[0], setSelectedId = ref[1];
    var handleNodeClick = function(data) {
        var ref;
        setSelectedId((data === null || data === void 0 ? void 0 : (ref = data.selectedNode) === null || ref === void 0 ? void 0 : ref.componentId) || null);
        onNodeClick(data);
    };
    react.useEffect(function() {
        setSelectedId(selectedNodeId);
    }, [
        selectedNodeId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedCanvasRenderer, {
        data: data,
        nodeConfig: nodeConfig,
        highlightedId: selectedId,
        deleteSelectedNode: deleteSelectedNode,
        moveNodeOrder: moveNodeOrder,
        triggerDoubleClick: triggerDoubleClick,
        onNodeClick: handleNodeClick,
        nodeIndex: [
            0
        ],
        onAddSection: onAddSection,
        disabledAddSection: disabledAddSection,
        onHightlightNodeAddClick: onHightlightNodeAddClick,
        onHightlightNodeDeleteClick: onHightlightNodeDeleteClick,
        onHightlightContainerAddClick: onHightlightContainerAddClick,
        onHightlightContainerDeleteClick: onHightlightContainerDeleteClick
    });
};

;// CONCATENATED MODULE: ./components/ComponentBuilder/ComponentBuilder.tsx







var ComponentBuilder_DefaultComponentMap = "div";
var SUPPORTED_CONTAINER_HIGHLIGHT = [
    "div",
    "section",
    "article",
    "Card"
];
var ComponentBuilder_isObjectEmpty = function(obj) {
    for(var key in obj){
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};
var ComponentBuilder_filterEmptyObjectFromArray = function(arr) {
    return arr.filter(function(obj) {
        return !ComponentBuilder_isObjectEmpty(obj);
    });
};
var ComponentBuilder_getSelectedComponentByName = function(componentName) {
    var componentByName = componentName || ComponentBuilder_DefaultComponentMap;
    var getComponentList = ComponentMap/* UIComponentMap */.gX;
    if (getComponentList[componentByName]) {
        return getComponentList[componentByName];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: " "
    });
};
// TODO: learn more about refs
// eslint-disable-next-line
var RenderComponentBlueprint = function(props) {
    var data = props.data, _highlightedId = props.highlightedId, highlightedId = _highlightedId === void 0 ? "nein" : _highlightedId, _isHightlightedChild = props.isHightlightedChild, isHightlightedChild = _isHightlightedChild === void 0 ? false : _isHightlightedChild, setHightlightedComponentId = props.setHightlightedComponentId, deleteSelectedNode = props.deleteSelectedNode, moveNodeOrder = props.moveNodeOrder, selectedNodeIndex = props.selectedNodeIndex, triggerDoubleClick = props.triggerDoubleClick;
    var componentDataList = data;
    if (componentDataList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: " "
        });
    }
    return componentDataList.map(function(componentNodeData) {
        var ref;
        var SelectedComponent = ComponentBuilder_getSelectedComponentByName(componentNodeData.componentName);
        var _$props = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.props) || {};
        var childrenNode = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.children) || [];
        var childNodes = ComponentBuilder_filterEmptyObjectFromArray(childrenNode);
        var componentClassName = (componentNodeData === null || componentNodeData === void 0 ? void 0 : (ref = componentNodeData.props) === null || ref === void 0 ? void 0 : ref.className) || "";
        var componentId = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.componentId) || "";
        var isComponentHasChildren = childNodes.length > 0;
        // const latestNodeIndex = Number(
        //   (selectedNodeIndex && selectedNodeIndex[selectedNodeIndex.length - 1]) ||
        //     0
        // )
        var isDisableMoveNodeUp = true // disabled for now because super buggy
        ;
        var isDisableMoveNodeDown = true // disable this for now because buggy
        ;
        var isHighlighted = componentId === highlightedId || isHightlightedChild;
        if (isHighlighted) {
            var highlightedEl = document.querySelector('[data-renderedId="'.concat(componentId, '"]'));
            highlightedEl === null || highlightedEl === void 0 ? void 0 : highlightedEl.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        }
        if (highlightedId && isHighlighted) {
            if (SUPPORTED_CONTAINER_HIGHLIGHT.includes(componentNodeData.componentName)) {
                return(// @ts-ignore
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                    "data-renderedId": componentId,
                    onClick: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        setHightlightedComponentId(componentNodeData);
                        triggerDoubleClick(false);
                    },
                    onDoubleClick: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        setHightlightedComponentId(componentNodeData);
                        triggerDoubleClick(true);
                    },
                    className: "".concat(componentClassName, " border-box z-10 m-[-4px] border-4 border-dashed border-pink-400"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute mt-[-35px] flex p-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " mr-2 flex rounded bg-[#f00] p-1 text-center",
                                            onClick: function() {
                                                return deleteSelectedNode();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                                color: "inverse",
                                                fontSize: "small",
                                                children: "delete"
                                            })
                                        }),
                                        (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.templateName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mr-2 rounded bg-[#77a6ff] p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs text-white",
                                                style: {
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                },
                                                children: componentNodeData.templateName
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mr-2 rounded bg-pink-400 p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs text-white",
                                                style: {
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                },
                                                children: componentNodeData.componentName
                                            })
                                        })
                                    ]
                                }),
                                !isDisableMoveNodeDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mr-2 flex rounded bg-[#390cff] p-1 text-center",
                                    onClick: function() {
                                        return moveNodeOrder("down", isComponentHasChildren);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                        color: "inverse",
                                        fontSize: "small",
                                        children: "expand_more"
                                    })
                                }),
                                !isDisableMoveNodeUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mr-2 flex rounded bg-[#390cff]\n                   p-1 text-center",
                                    onClick: function() {
                                        return moveNodeOrder("up", isComponentHasChildren);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                        color: "inverse",
                                        fontSize: "small",
                                        children: "expand_less"
                                    })
                                })
                            ]
                        }),
                        childNodes && childNodes.map(function(child) {
                            return RenderComponentBlueprint({
                                data: [
                                    child
                                ],
                                highlightedId: highlightedId,
                                isHightlightedChild: child.componentId === highlightedId,
                                setHightlightedComponentId: setHightlightedComponentId,
                                deleteSelectedNode: deleteSelectedNode,
                                moveNodeOrder: moveNodeOrder,
                                selectedNodeIndex: selectedNodeIndex,
                                triggerDoubleClick: triggerDoubleClick
                            });
                        })
                    ]
                }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId)));
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-box z-10 m-[-4px] border-4 border-dashed border-pink-400",
                onClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    setHightlightedComponentId(componentNodeData);
                    triggerDoubleClick(false);
                },
                onDoubleClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    setHightlightedComponentId(componentNodeData);
                    triggerDoubleClick(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute mt-[-35px] flex p-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mr-2 flex rounded bg-[#f00] p-1 text-center",
                                    onClick: function() {
                                        return deleteSelectedNode();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                        color: "inverse",
                                        fontSize: "small",
                                        children: "delete"
                                    })
                                }),
                                (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.templateName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 rounded bg-[#77a6ff] p-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs text-white",
                                        style: {
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        },
                                        children: componentNodeData.templateName
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 rounded bg-pink-400 p-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs text-white",
                                        style: {
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        },
                                        children: componentNodeData.componentName
                                    })
                                }),
                                !isDisableMoveNodeDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mr-2 flex rounded bg-[#390cff] p-1 text-center",
                                    onClick: function() {
                                        return moveNodeOrder("down", isComponentHasChildren);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                        color: "inverse",
                                        fontSize: "small",
                                        children: "expand_more"
                                    })
                                }),
                                !isDisableMoveNodeUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " mr-2 flex rounded bg-[#390cff]\n                   p-1 text-center",
                                    onClick: function() {
                                        return moveNodeOrder("up", isComponentHasChildren);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                        color: "inverse",
                                        fontSize: "small",
                                        children: "expand_less"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                        "data-renderedId": componentId,
                        onClick: function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            setHightlightedComponentId(componentNodeData);
                            triggerDoubleClick(false);
                        },
                        onDoubleClick: function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            setHightlightedComponentId(componentNodeData);
                            triggerDoubleClick(true);
                        },
                        children: [
                            childNodes && childNodes.map(function(child) {
                                return RenderComponentBlueprint({
                                    data: [
                                        child
                                    ],
                                    highlightedId: highlightedId,
                                    isHightlightedChild: child.componentId === highlightedId,
                                    setHightlightedComponentId: setHightlightedComponentId,
                                    deleteSelectedNode: deleteSelectedNode,
                                    moveNodeOrder: moveNodeOrder,
                                    selectedNodeIndex: selectedNodeIndex,
                                    triggerDoubleClick: triggerDoubleClick
                                });
                            }),
                            !isDisableMoveNodeDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " mr-2 flex rounded bg-[#390cff] p-1 text-center",
                                onClick: function() {
                                    return moveNodeOrder("down", isComponentHasChildren);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                    color: "inverse",
                                    fontSize: "small",
                                    children: "expand_more"
                                })
                            }),
                            !isDisableMoveNodeUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " mr-2 flex rounded bg-[#390cff]\n                   p-1 text-center",
                                onClick: function() {
                                    return moveNodeOrder("up", isComponentHasChildren);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                                    color: "inverse",
                                    fontSize: "small",
                                    children: "expand_less"
                                })
                            })
                        ]
                    }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId))
                ]
            }, "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId));
        }
        return(// @ts-ignore
        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: componentClassName
        }, _$props), {
            onClick: function(e) {
                e.stopPropagation();
                e.preventDefault();
                setHightlightedComponentId(componentNodeData);
                triggerDoubleClick(false);
            },
            onDoubleClick: function(e) {
                e.stopPropagation();
                e.preventDefault();
                setHightlightedComponentId(componentNodeData);
                triggerDoubleClick(true);
            },
            children: childNodes && childNodes.map(function(child) {
                return RenderComponentBlueprint({
                    data: [
                        child
                    ],
                    highlightedId: highlightedId,
                    isHightlightedChild: child.componentId === highlightedId,
                    setHightlightedComponentId: setHightlightedComponentId,
                    deleteSelectedNode: deleteSelectedNode,
                    moveNodeOrder: moveNodeOrder,
                    selectedNodeIndex: selectedNodeIndex,
                    triggerDoubleClick: triggerDoubleClick
                });
            })
        }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId)));
    });
};
var MemoizedRenderComponentBlueprint = /*#__PURE__*/ react.memo(RenderComponentBlueprint);
// eslint-disable-next-line
var RenderComponent = function(props) {
    var data = props.data, _highlightedId = props.highlightedId, highlightedId = _highlightedId === void 0 ? "" : _highlightedId, _isHightlightedChild = props.isHightlightedChild, isHightlightedChild = _isHightlightedChild === void 0 ? false : _isHightlightedChild, _nodeConfig = props.nodeConfig, nodeConfig = _nodeConfig === void 0 ? null : _nodeConfig;
    var componentDataList = data;
    if (componentDataList.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: " "
        });
    }
    return componentDataList.map(function(componentNodeData) {
        var ref;
        var SelectedComponent = ComponentBuilder_getSelectedComponentByName(componentNodeData.componentName);
        var _$props = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.props) || {};
        var childrenNode = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.children) || [];
        var childNodes = ComponentBuilder_filterEmptyObjectFromArray(childrenNode);
        var componentClassName = (componentNodeData === null || componentNodeData === void 0 ? void 0 : (ref = componentNodeData.props) === null || ref === void 0 ? void 0 : ref.className) || "";
        var componentId = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.componentId) || "";
        var isHighlighted = componentId === highlightedId || isHightlightedChild;
        var overrideComponentData = {
            props: _$props,
            children: childNodes
        };
        var eventListenerId = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.eventListenerId) || "";
        if (eventListenerId && nodeConfig) {
            overrideComponentData = {
                props: (0,_object_spread/* default */.Z)({}, _$props, nodeConfig[eventListenerId].props),
                children: (0,_to_consumable_array/* default */.Z)(childNodes).concat((0,_to_consumable_array/* default */.Z)(nodeConfig[eventListenerId].children || []))
            };
        }
        if (highlightedId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n            ".concat(isHighlighted ? "my-1 rounded-sm border-2 border-dashed border-pink-400 p-1" : ""),
                style: {
                    zIndex: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: componentClassName
                }, overrideComponentData.props), {
                    children: overrideComponentData.children && overrideComponentData.children.map(function(child) {
                        return RenderComponent({
                            data: [
                                child
                            ],
                            highlightedId: highlightedId,
                            isHightlightedChild: child.componentId === highlightedId,
                            nodeConfig: nodeConfig
                        });
                    })
                }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId))
            }, "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId));
        }
        return(// @ts-ignore
        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: componentClassName
        }, overrideComponentData.props), {
            children: overrideComponentData.children && overrideComponentData.children.map(function(child) {
                return RenderComponent({
                    data: [
                        child
                    ],
                    highlightedId: highlightedId,
                    isHightlightedChild: child.componentId === highlightedId,
                    nodeConfig: nodeConfig
                });
            })
        }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId)));
    });
};
var ComponentBuilder = function(props) {
    var data = props.data, _highlightedId = props.highlightedId, highlightedId = _highlightedId === void 0 ? "" : _highlightedId, _isHightlightedChild = props.isHightlightedChild, isHightlightedChild = _isHightlightedChild === void 0 ? false : _isHightlightedChild, isBlueprint = props.isBlueprint, setHightlightedComponentId = props.setHightlightedComponentId, _nodeConfig = props.nodeConfig, nodeConfig = _nodeConfig === void 0 ? null : _nodeConfig, deleteSelectedNode = props.deleteSelectedNode, moveNodeOrder = props.moveNodeOrder, selectedNodeIndex = props.selectedNodeIndex, triggerDoubleClick = props.triggerDoubleClick;
    if (isBlueprint) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedRenderComponentBlueprint, {
            data: data,
            highlightedId: highlightedId,
            isHightlightedChild: isHightlightedChild,
            setHightlightedComponentId: setHightlightedComponentId,
            deleteSelectedNode: deleteSelectedNode,
            moveNodeOrder: moveNodeOrder,
            selectedNodeIndex: selectedNodeIndex,
            triggerDoubleClick: triggerDoubleClick
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, {
        data: data,
        highlightedId: highlightedId,
        isHightlightedChild: isHightlightedChild,
        nodeConfig: nodeConfig
    });
};
/* harmony default export */ var ComponentBuilder_ComponentBuilder = ((/* unused pure expression or super */ null && (ComponentBuilder)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/ComponentBuilder/ComponentRenderer.tsx








var ComponentRenderer_RenderComponent = function(props) {
    var data = props.data, nodeConfig = props.nodeConfig;
    var componentDataList = data;
    if (componentDataList.length === 0) {
        return null;
    }
    return componentDataList.map(function(componentNodeData) {
        var ref;
        var SelectedComponent = getSelectedComponentByName(componentNodeData.componentName);
        var _$props = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.props) || {};
        var childrenNode = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.children) || [];
        var childNodes = filterEmptyObjectFromArray(childrenNode);
        var overrideComponentData = {
            props: _$props,
            children: childNodes
        };
        var eventListenerId = (componentNodeData === null || componentNodeData === void 0 ? void 0 : componentNodeData.eventListenerId) || (componentNodeData === null || componentNodeData === void 0 ? void 0 : (ref = componentNodeData.props) === null || ref === void 0 ? void 0 : ref.id) || "";
        if (eventListenerId && nodeConfig && nodeConfig[eventListenerId]) {
            var componentDataChildNodes = Array.isArray(childNodes) ? childNodes : [];
            overrideComponentData = {
                props: (0,_object_spread/* default */.Z)({}, _$props, nodeConfig[eventListenerId].props),
                children: (0,_to_consumable_array/* default */.Z)(componentDataChildNodes).concat((0,_to_consumable_array/* default */.Z)(nodeConfig[eventListenerId].children || []))
            };
        }
        return(// @ts-ignore <- bypass err construct call signature of jsx
        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overrideComponentData.props), {
            children: overrideComponentData.children && overrideComponentData.children.map(function(child) {
                return ComponentRenderer_RenderComponent({
                    data: [
                        child
                    ],
                    nodeConfig: nodeConfig
                });
            })
        }), "".concat(componentNodeData.componentName, "-").concat(componentNodeData.componentId)));
    });
};
var MemoizedRenderer = /*#__PURE__*/ react.memo(function(props) {
    return(// @ts-ignore <- bypass default renderer type (because we do custom render / pointer)
    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentRenderer_RenderComponent, {
        data: props.data,
        nodeConfig: props.nodeConfig
    }));
});
var ComponentRenderer = function(props) {
    var supportedNodeEventMap = [
        "onClick",
        "onMouseEnter",
        "onMouseLeave"
    ];
    var data = props.data, _nodeConfig = props.nodeConfig, nodeConfig = _nodeConfig === void 0 ? null : _nodeConfig;
    var nodeFunctionMap = {
        changeNode: function(eventId, dataKey, dataValue) {
            try {
                var parsedValue = JSON.parse(dataValue);
                setNodeState(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, eventId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState[eventId]), (0,_define_property/* default */.Z)({}, dataKey, parsedValue))));
                });
            } catch (e) {
                console.error(e);
            }
        }
    };
    var parseEventStringToFunction = function(eventString) {
        try {
            var functionName = eventString.match(/([a-z0-9]+)/gi)[0];
            var functionArgs = eventString.match(/\(([^)]+)\)/)[1];
            var parsedArgs = functionArgs.split(",").map(function(arg) {
                return arg.trim();
            });
            var targetEventId = parsedArgs[0];
            var targetDataKey = parsedArgs[1];
            var targetDataValue = parsedArgs[2];
            return function() {
                nodeFunctionMap[functionName](targetEventId, targetDataKey, targetDataValue);
            };
        } catch (e) {
            console.error(e);
        }
    };
    var generateNodeConfigEventFn = function() {
        if (nodeConfig) {
            return Object.keys(nodeConfig).reduce(function(acc, eventId) {
                // change this to support multiple event listener
                var eventListenerKey = supportedNodeEventMap.find(function(event) {
                    return nodeConfig[eventId].props[event];
                });
                var eventListenerFn = eventListenerKey && nodeConfig[eventId].props[eventListenerKey];
                if (eventListenerFn) {
                    try {
                        var parsedFn = parseEventStringToFunction(eventListenerFn);
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, eventId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nodeConfig[eventId]), {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nodeConfig[eventId].props), (0,_define_property/* default */.Z)({}, eventListenerKey, parsedFn))
                        })));
                    } catch (e) {
                        console.error(e);
                    }
                }
                return acc;
            }, {});
        }
        return null;
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(generateNodeConfigEventFn()), 2), nodeState = ref[0], setNodeState = ref[1];
    // @ts-ignore TODO fix this later
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedRenderer, {
        data: data,
        nodeConfig: nodeState
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js
var text_dist_index_esm = __webpack_require__(73041);
;// CONCATENATED MODULE: ./components/ComponentBuilder/FormBuilder.tsx








var FormBuilder_DefaultComponentMap = "Input";
var getProperDataValueType = function(data) {
    var checkIfArray = function(data) {
        return Array.isArray(data);
    };
    var checkIfNull = function(data) {
        return data === null;
    };
    var getProperDataType = function(data) {
        if (checkIfNull(data)) return "string";
        if (checkIfArray(data)) return "array";
        return typeof data === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(data);
    };
    return getProperDataType(data);
};
var formToTypeMap = function(data) {
    var isConfigData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ignoreConfigKeys = [
        "excludeKeys"
    ];
    var schemaFormMap = [];
    if (isConfigData) {
        schemaFormMap = Object.keys(data).map(function(key) {
            return {
                name: key,
                type: data[key].type
            };
        }).filter(function(item) {
            return ignoreConfigKeys.indexOf(item.name) === -1;
        });
    } else {
        schemaFormMap = Object.keys(data).map(function(key) {
            return {
                name: key,
                type: getProperDataValueType(data[key])
            };
        });
    }
    return schemaFormMap;
};
var FormBuilder_getSelectedComponentByName = function(componentName) {
    var componentByName = componentName || FormBuilder_DefaultComponentMap;
    var getComponentList = ComponentMap/* FormComponentMap */.xL;
    if (getComponentList[componentByName]) {
        return getComponentList[componentByName];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: " "
    });
};
var ComponentSelector = /*#__PURE__*/ react.memo(function(props) {
    var ref, ref1;
    var formName = props.name, type = props.type, _config = props.config, config = _config === void 0 ? {} : _config, formDefaultValue = props.defaultValue;
    var getComponentNameByType = ComponentMap/* formComponentMapToType */.dl[type] || "Input";
    var componentName = (config === null || config === void 0 ? void 0 : config.componentName) || getComponentNameByType[0];
    var SelectedComponent = FormBuilder_getSelectedComponentByName(componentName);
    var methods = (0,react_hook_form_dist_index_esm/* useFormContext */.Gc)();
    var control = methods.control, formState = methods.formState;
    var errors = formState.errors;
    var currentDefaultValue = (config === null || config === void 0 ? void 0 : (ref = config.props) === null || ref === void 0 ? void 0 : ref.defaultValue) || formDefaultValue;
    var valueObj = {
        defaultValue: currentDefaultValue
    };
    var errorMessageAlert = {
        errorMessage: errors === null || errors === void 0 ? void 0 : (ref1 = errors[formName]) === null || ref1 === void 0 ? void 0 : ref1.message
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-4 flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                variant: "helper-bold",
                children: config.label || formName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hook_form_dist_index_esm/* Controller */.Qr, {
                control: control,
                name: formName,
                rules: (0,_object_spread/* default */.Z)({
                    required: "Wajib diisi"
                }, config.rules),
                defaultValue: currentDefaultValue,
                render: function(param) {
                    var onChange = param.field.onChange;
                    return(// @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "my-2 ".concat(config.className)
                    }, errorMessageAlert), {
                        id: formName,
                        name: formName
                    }), config.props, valueObj), {
                        onChange: function(value) {
                            return onChange(value);
                        }
                    }), formName));
                }
            }),
            componentName === "Input" && /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                color: "critical",
                variant: "helper",
                children: errorMessageAlert === null || errorMessageAlert === void 0 ? void 0 : errorMessageAlert.errorMessage
            })
        ]
    });
});
ComponentSelector.displayName = "ComponentSelector";
var InputBuilder = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _data = props.data, data = _data === void 0 ? {} : _data, config = props.config, _configOverride = props.configOverride, configOverride = _configOverride === void 0 ? false : _configOverride;
    var formTypeMap = (configOverride ? formToTypeMap(config, configOverride) : formToTypeMap(data)) || [];
    var formConfig = config || {};
    var _excludeKeys = formConfig.excludeKeys, excludeKeys = _excludeKeys === void 0 ? [] : _excludeKeys;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: formTypeMap.map(function(formSchema) {
            return !excludeKeys.includes(formSchema.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentSelector, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formSchema), {
                config: (0,_object_spread/* default */.Z)({}, formConfig[formSchema.name]),
                defaultValue: data[formSchema.name],
                ref: ref
            }), formSchema.name);
        })
    });
});
InputBuilder.displayName = "InputBuilder";
var FormBuilder = function(props) {
    var data = props.data, config = props.config, _configOverride = props.configOverride, configOverride = _configOverride === void 0 ? false : _configOverride, _onSubmitButtonClick = props.onSubmitButtonClick, onSubmitButtonClick = _onSubmitButtonClick === void 0 ? function() {
        return {};
    } : _onSubmitButtonClick, _submitButtonClass = props.submitButtonClass, submitButtonClass = _submitButtonClass === void 0 ? "" : _submitButtonClass, _submitButtonText = props.submitButtonText, submitButtonText = _submitButtonText === void 0 ? "Submit" : _submitButtonText, _submitButonProps = props.submitButonProps, submitButonProps = _submitButonProps === void 0 ? {} : _submitButonProps, _formClass = props.formClass, formClass = _formClass === void 0 ? "" : _formClass, _formMode = props.formMode, formMode = _formMode === void 0 ? "onSubmit" : _formMode;
    var methods = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        mode: formMode
    });
    var handleSubmit = methods.handleSubmit;
    var onSubmit = function(val) {
        onSubmitButtonClick(val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hook_form_dist_index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: formClass,
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBuilder, {
                    data: data,
                    config: config,
                    configOverride: configOverride
                }),
                props.children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    type: "submit",
                    className: submitButtonClass
                }, submitButonProps), {
                    children: submitButtonText
                }))
            ]
        })
    }));
};
/* harmony default export */ var ComponentBuilder_FormBuilder = ((/* unused pure expression or super */ null && (InputBuilder)));
var useFormBuilderContext = react_hook_form_dist_index_esm/* useFormContext */.Gc;

// EXTERNAL MODULE: ./node_modules/react-grid-layout/index.js
var react_grid_layout = __webpack_require__(69968);
var react_grid_layout_default = /*#__PURE__*/__webpack_require__.n(react_grid_layout);
;// CONCATENATED MODULE: ./components/ComponentBuilder/GridBuilder.tsx






var GridBuilder_DefaultComponentMap = "div";
var GridBuilder_isObjectEmpty = function(obj) {
    for(var key in obj){
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};
var GridBuilder_filterEmptyObjectFromArray = function(arr) {
    return arr.filter(function(obj) {
        return !GridBuilder_isObjectEmpty(obj);
    });
};
var GridBuilder_getSelectedComponentByName = function(componentName) {
    var componentByName = componentName || GridBuilder_DefaultComponentMap;
    var getComponentList = ComponentMap/* UIComponentMap */.gX;
    if (getComponentList[componentByName]) {
        return getComponentList[componentByName];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: " "
    });
};
var RenderGridItemBuilder = function(props) {
    var data = props.data, builderConfig = props.builderConfig;
    var isPreviewMode = builderConfig.isPreviewMode, onNodeClick = builderConfig.onNodeClick;
    if (data.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return data.map(function(gridItem) {
        var SelectedComponent = GridBuilder_getSelectedComponentByName(gridItem.componentName);
        var _$props = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.props) || {};
        var componentId = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.componentId) || "";
        var childrenNode = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.children) || [];
        var childNodes = GridBuilder_filterEmptyObjectFromArray(childrenNode);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full overflow-hidden",
            onClick: function(e) {
                e.stopPropagation();
                onNodeClick && onNodeClick(gridItem);
            },
            children: [
                !isPreviewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute h-full w-full cursor-grab border-4 border-dashed border-pink-400"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                        "data-renderedid": componentId,
                        onClick: function(e) {
                            e.stopPropagation();
                            onNodeClick && onNodeClick(gridItem);
                        },
                        children: childNodes && childNodes.map(function(child) {
                            return RenderGridItemBuilder({
                                data: [
                                    child
                                ],
                                onNodeClick: onNodeClick
                            });
                        })
                    }))
                })
            ]
        }, componentId);
    });
};
var RenderGridItem = function(props) {
    var data = props.data;
    if (data.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return data.map(function(gridItem) {
        var SelectedComponent = GridBuilder_getSelectedComponentByName(gridItem.componentName);
        var _$props = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.props) || {};
        var componentId = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.componentId) || "";
        var childrenNode = (gridItem === null || gridItem === void 0 ? void 0 : gridItem.children) || [];
        var childNodes = GridBuilder_filterEmptyObjectFromArray(childrenNode);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full w-full overflow-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                "data-renderedid": componentId,
                children: childNodes && childNodes.map(function(child) {
                    return RenderGridItem({
                        data: [
                            child
                        ]
                    });
                })
            }))
        }, componentId);
    });
};
var DEFAULT_GRID_LAYOUT_CONFIG = {
    useCSSTransforms: false,
    compactType: "vertical",
    cols: 12,
    isBounded: true,
    margin: [
        0,
        0
    ],
    rowHeight: 50,
    containerPadding: [
        0,
        0
    ],
    width: 1200,
    allowOverlap: true
};
var GridBuilder = function(props) {
    var data = props.data, _config = props.config, config = _config === void 0 ? null : _config, _builderConfig = props.builderConfig, builderConfig = _builderConfig === void 0 ? null : _builderConfig;
    var layoutConfig = (0,_object_spread/* default */.Z)({}, DEFAULT_GRID_LAYOUT_CONFIG, config);
    if (builderConfig) return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_grid_layout_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, layoutConfig), {
        style: {
            minHeight: "500px",
            zIndex: 2
        }
    }), builderConfig), {
        children: RenderGridItemBuilder({
            data: data,
            builderConfig: builderConfig
        })
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_grid_layout_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, layoutConfig), {
        style: {
            minHeight: "500px",
            zIndex: 2
        }
    }), builderConfig), {
        children: RenderGridItem({
            data: data,
            builderConfig: builderConfig
        })
    }));
};
/* harmony default export */ var ComponentBuilder_GridBuilder = ((/* unused pure expression or super */ null && (GridBuilder)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/Image/imageResponsive.module.css
var imageResponsive_module = __webpack_require__(36502);
var imageResponsive_module_default = /*#__PURE__*/__webpack_require__.n(imageResponsive_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
// DOESN'T WORK, REWORK THIS






var ImageWrapper = function(props) {
    var src = props.src, width = props.width, height = props.height, _alt = props.alt, alt = _alt === void 0 ? "cartool-image" : _alt, className = props.className, imageProps = (0,_object_without_properties/* default */.Z)(props, [
        "src",
        "width",
        "height",
        "alt",
        "className"
    ]);
    var isResponsive = !width && !height ? {
        layout: "fill",
        objectFit: "contain"
    } : {
        width: width,
        height: height
    };
    try {
        // @ts-ignore
        return /*#__PURE__*/ react.createElement((__webpack_require__(25675)["default"]), (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            src: typeof src === "string" ? src : src.src
        }, isResponsive), {
            alt: alt,
            className: "".concat((imageResponsive_module_default()).image, " ").concat(className)
        }), imageProps));
    } catch (e) {
        return /*#__PURE__*/ react.createElement("img", (0,_object_spread/* default */.Z)({
            src: src,
            width: width,
            height: height,
            alt: alt,
            className: className
        }, imageProps));
    }
};
var Image = function(props) {
    var src = props.src, _width = props.width, width = _width === void 0 ? 0 : _width, _height = props.height, height = _height === void 0 ? 0 : _height, _alt = props.alt, alt = _alt === void 0 ? "cartool-image" : _alt, className = props.className, containerClassName = props.containerClassName, imageProps = (0,_object_without_properties/* default */.Z)(props, [
        "src",
        "width",
        "height",
        "alt",
        "className",
        "containerClassName"
    ]);
    var isResponsive = !width && !height ? {
        layout: "fill",
        objectFit: "contain"
    } : {
        width: width,
        height: height
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((imageResponsive_module_default())["image-container"], " ").concat(containerClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            src: src,
            alt: alt
        }, isResponsive), {
            className: "".concat((imageResponsive_module_default()).image, " ").concat(className)
        }), imageProps))
    });
};

;// CONCATENATED MODULE: ./components/index.ts






// custom component



/***/ }),

/***/ 36502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image-container":"imageResponsive_image-container__Ly51u","image":"imageResponsive_image__d7afl"};

/***/ })

}]);